import { useCallback, useMemo } from 'react';

import SearchIcon from '@mui/icons-material/Search';
import { FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput } from '@mui/material';
import _debounce from 'lodash/debounce';

interface DebouncedInputProps {
  generalFilterLabel: string;
  handleChangeValue(value: string): void;
}

export const DebouncedInput = ({ handleChangeValue, generalFilterLabel }: DebouncedInputProps) => {
  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      handleChangeValue(e.target.value);
    },
    [handleChangeValue]
  );

  const debounceChange = useMemo(() => _debounce((e) => handleChange(e), 500), [handleChange]);

  const label = generalFilterLabel || 'Search';

  return (
    <FormControl sx={{ m: 1, width: '100%' }} variant="outlined">
      <InputLabel htmlFor="search-input">{label}</InputLabel>
      <OutlinedInput
        name="search"
        id="search-input"
        type="text"
        fullWidth
        label={label}
        onChange={debounceChange}
        endAdornment={
          <InputAdornment position="end">
            <IconButton edge="end">
              <SearchIcon />
            </IconButton>
          </InputAdornment>
        }
      />
    </FormControl>
  );
};
